import React from "react";
import classes from "./DiagnosisCard.module.scss";
import { useNavigate } from "react-router-dom";
import ranking1 from "../../static/images/ranking/ranking-1.png";
import ranking2 from "../../static/images/ranking/ranking-2.png";
import ranking3 from "../../static/images/ranking/ranking-3.png";
import ranking4 from "../../static/images/ranking/ranking-4.png";
import ranking5 from "../../static/images/ranking/ranking-5.png";

type Props = {
  type: "ranking" | "diagnosis";
  index: number;
  summary?: string;
  tag: string;
  imageData: string;
  internalUrl: string;
  callback?: () => void;
  done?: boolean;
  expectedTime?: number;
};

const DiagnosisCard = (props: Props) => {
  const navigate = useNavigate();
  const acquiredPoint = 10000;
  const getRank = (index: number) => {
    if (index === 0) {
      return ranking1;
    }

    if (index === 1) {
      return ranking2;
    }

    if (index === 2) {
      return ranking3;
    }

    if (index === 3) {
      return ranking4;
    }

    return ranking5;
  };

  const click = () => {
    if (props.internalUrl != null && props.internalUrl !== "") {
      navigate(props.internalUrl);
    }

    if (props.callback != null) {
      props.callback();
    }
  };

  return (
    <div className={classes.container} onClick={click}>
      {props.summary != null ? (
        <>
          <div className={classes.left}>
            <img
              className={classes.image}
              src={props.imageData}
              alt={props.imageData}
            />
            {props.type === "ranking" && (
              <img
                className={classes.rank}
                src={getRank(props.index)}
                alt={getRank(props.index)}
              />
            )}
          </div>
          <div className={classes.right}>
            <div className={classes.metaRow}>
              {props.expectedTime != null && (
                <span className={classes.expectedTime}>所要時間：約{props.expectedTime}分</span>
              )}
              <span className={classes.tag}>{props.tag}</span>
            </div>
            <div className={classes.summary}>{props.summary}</div>
            {props.done != null && (
              <div className={classes.footerRow}>
                <div className={classes.pointTag}>
                  {acquiredPoint.toLocaleString("ja-JP")}pt
                </div>
                {props.done ? (
                  <div className={classes.done}>実施済</div>
                ) : (
                  <div className={classes.yet}>未挑戦</div>
                )}
              </div>
            )}
          </div>
        </>
      ) : (
        <div className={classes.wide}>
          <img
            className={classes.image}
            src={props.imageData}
            alt={props.imageData}
          />
        </div>
      )}
    </div>
  );
};

export default DiagnosisCard;
